<div class="row">
  <strong>Alert Frequency</strong>
</div>
<div class="row">
  <div class="col-md-2">
    <app-eca-checkbox label="90 days before"
                      [(value)]="companyAlertSettings.alertMinus90Days"
                      [disable]="!editingType">
    </app-eca-checkbox>
  </div>
  <div class="col-md-2">
    <app-eca-checkbox label="60 days before"
                      [(value)]="companyAlertSettings.alertMinus60Days"
                      [disable]="!editingType">
    </app-eca-checkbox>
  </div>
  <div class="col-md-2">
    <app-eca-checkbox label="30 days before"
                      [(value)]="companyAlertSettings.alertMinus30Days"
                      [disable]="!editingType">
    </app-eca-checkbox>
  </div>
  <div class="col-md-2">
    <app-eca-checkbox label="14 days before"
                      [(value)]="companyAlertSettings.alertMinus14Days"
                      [disable]="!editingType">
    </app-eca-checkbox>
  </div>
  <div class="col-md-2">
    <app-eca-checkbox label="On the day"
                      [(value)]="companyAlertSettings.alert0Days"
                      [disable]="!editingType">
    </app-eca-checkbox>
  </div>
  <div class="col-md-2">
    <app-eca-checkbox label="14 days after"
                      [(value)]="companyAlertSettings.alert14Days"
                      [disable]="!editingType"
                      popoverText="Frequency settings for when alert emails should be sent out">
    </app-eca-checkbox>
  </div>
</div>
